<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="signUpInfo">
		<Loading v-if="show"></Loading>
		<div class="signUpInfo_container">
			<div class="nav" v-if="navShow">
				<a :href="navhomeUrl" target="_top">首页</a>
				> <a>照片直播</a>
			</div>
			<div class="banner-img">
				<img :src="meetingInfo.MobileBannerImage" v-if="meetingInfo.MobileBannerImage!=null&&red!='im'">
				<div class="nav-bar">
					<div class="nav-bar-num">
						<img src="../../assets/photo.png">{{allphotonums}}
					</div>
				</div>
			</div>
			<div class="signUpInfo_content">
				<div id="meeting_info" class="commonW">
					<div v-if="photoList!=null && photoList.length>0">
						<div class="schedule-meeting" v-if="photoList!=null && photoList.length>0">
							<div class="meeting-list" v-for="(item,index) in photoList" :key='index'
								@click="toDetail(item.clid)">
								<div class="meeting-liveBanner">
									<img :src="item.topImage">
								</div>
								<div class="meeting-con">
									<div class="meeting-title">
										{{item.cname}}
									</div>
									<div class="meeting-live">
										<div class="meeting-liveTimer">
											<img src="../../assets/photo.png">{{item.photonums}}
										</div>
										<div class="meeting-liveTimer">
											<span class="meeting-btn">进入相册</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="noDate" v-else>
						暂无会议信息
					</div>
				</div>
				<div class="loading" v-if="loading">
					<van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...
					</van-loading>
				</div>
			</div>
		</div>
		<Footer :footInfo="this.footInfo"></Footer>
	</div>
</template>
<script>
	import Loading from '@components/Loading.vue'
	import Footer from '@components/FooterBlack.vue'
	import publicSignup from '../../lib/signUp.js'
	import wxShare from '../../lib/wxShare.js'
	export default {
		name: 'photoList',
		components: {
			Footer,
			Loading,
		},
		data() {
			return {
				publicSignup: {}, //通用js
				params: {
					m: '',
					red: '',
				},
				meetingInfo: '',
				show: false,
				loading: false,
				photoList: [],
				red: '',
				navShow: true,
				navhomeUrl: '',
				allphotonums: 0,
				allviewnum: 0,
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
			}
		},
		created() {
			this.params = this.$route.query
			this.red = this.params.red
			this.publicSignup = new publicSignup()
			console.log(this.publicSignup)
			let opt = {
				m: this.params.m
			}
			this.initmeeting(opt)
			this.getPhotoList(opt)
		},
		mounted() {
			//this.swiperInit()
		},
		methods: {
			async initmeeting(opt) {
				this.show = true
				this.meetingInfo = await this.publicSignup.init(opt, this)
				if (this.meetingInfo.Code === 1000) {
					this.footInfo.LogoTxt = this.meetingInfo.LogoTxt
					this.footInfo.LogoLink = this.meetingInfo.LogoLink
					this.footInfo.LogoImg = this.meetingInfo.LogoImg
					this.show = false
					if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
						this.navShow = false
					} else {
						this.navShow = true
						this.navhomeUrl = this.meetingInfo.HomeUrl
					}
				} else {
					this.$notify({
						massage: this.meetingInfo.Msg,
						type: 'danger',
						duration: '3000',
					})
				}
			},
			/**
			 * 初始化会议列表数据
			 */
			async getPhotoList(opt) {
				try {
					this.loading = true
					let res = await this.$http.photoList(opt)
					console.log(res)
					this.loading = false
					this.photoList = res
					for (let i in this.photoList) {
						this.allphotonums = this.allphotonums + this.photoList[i].photonums
						this.allviewnum = this.allviewnum + this.photoList[i].viewnum
					}
				} catch (err) {
					console.log(err)
				}
			},


			toDetail(clid) {
				const params = {
					m: this.params.m,
					clid: clid,
				}
				const {
					m
				} = this.$route.query
				this.$router.push({
					path: '/photoDetail',
					query: {
						m,
						...params
					},
				})
			},


			//微信分享
			async initShare(title, desc, link, imgUrl) {
				try {
					const headRes = await this.$http.csData({
						url: encodeURIComponent(
							window.location.href.replace(location.hash, '')
						),
					})
					console.log(headRes, 'headRes')
					const _Wx = new wxShare({
						opt: headRes,
					})
					_Wx.ready().then((wx) => {
						_Wx.share(title, desc, link, imgUrl)
						console.log(wx)
					})
					//this.headRess = _Wx
				} catch (err) {
					console.log(err)
				}
			},
		},
	}
</script>
<style lang="scss">
	.payDialog {
		.van-dialog__message {
			font-size: 32px;
			height: 100px;
			line-height: 100px;
		}

		.van-button {
			height: 100px;
			line-height: 100px;
		}

		.van-button__text {
			font-size: 32px;
		}

	}

	.swiper-pagination-bullet {
		width: 14px !important;
		height: 14px !important;
	}
</style>
<style lang="scss" scoped>
	.signUpInfo-banner {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.signUpInfo-banner .swiper-slide {
		position: relative;
		text-align: center;
	}

	.signUpInfo-banner img {
		max-width: 100%;
		display: block;
	}

	.commonW {
		width: 100%;
		margin: 0 auto;
	}

	// ----------
	#signUpInfo {
		.signUpInfo_container {
			background: #0a0a0a;
			padding-bottom: 100px;

			.live-data {
				border-top: 1px dashed #e2e8f0;
				display: flex;

				.liveDiv {
					flex: 1;
					text-align: center;
					padding: 20px 0;
					font-size: 26px;

					p {
						color: #1e293b;
						padding: 5px 0;
					}

					p:last-child span {
						font-size: 34px;
						color: #3b82f6;
						font-weight: bold;
					}
				}
			}

			.note {
				text-align: center;
				font-size: 22px;
				color: #64748b;
				margin-top: 20px;
			}

			.pay-btns {
				height: 60px;
				margin-top: 20px;
				border-top: 1px dashed #e2e8f0;
				padding-top: 20px;

				.pay-btn {
					background: linear-gradient(135deg, #3b82f6, #6366f1);
					width: 200px;
					height: 60px;
					text-align: center;
					line-height: 60px;
					color: #fff;
					float: right;
					margin-right: 20px;
				}
			}

			.signUpInfo_content {
				.signUpInfo-banner {
					>img {
						width: 100%;
					}
				}
			}
		}

		.van-dialog {
			width: 70%;
			text-align: center;
			font-size: 32px;
			padding-top: 20px;

			.van-dialog__content {
				margin: 20px;
			}

			.van-button {
				font-size: 32px;
				line-height: 60px;
				height: 60px;
			}
		}
	}

	.schedule-date {
		display: flex;
		flex-wrap: wrap;
		padding: 20px 20px 0;
	}

	.schedule-date-item {
		cursor: pointer;
		float: left;
		background: #f8fafc;
		border-radius: 8px;
		height: 100px;
		width: calc((100% - 48px)/4);
		margin-right: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
		flex-direction: column;
	}

	.schedule-date-item:nth-child(4n) {
		margin-right: 0;
	}

	.schedule-date-item.active {
		border: 2px solid #3b82f6;
		background: #fff;
	}

	.item-liveWeek {
		font-size: 26px;
		line-height: 37px;
		color: #64748b;
	}

	.item-liveDate {
		line-height: 48px;
		font-size: 34px;
		font-weight: 600;
		color: #1e293b;
	}


	.schedule-meeting {
		margin-top: 20px;
		padding: 0 20px;
	}

	.meeting-list {
		display: flex;
		margin-bottom: 20px;
		background-color: #000;
		box-shadow: 0 0 20px rgba(0, 0, 0, .1);
		overflow: hidden;
		border-bottom: 1px solid #e2e8f0;
		padding-bottom: 20px;
	}

	.meeting-list:last-child {
		padding-bottom: 0;
		border-bottom: none;
	}

	.meeting-liveBanner {
		width: 240px;
		height: 135px;
	}

	.meeting-liveBanner img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.meeting-con {
		flex: 1;
		margin-left: 20px;
	}

	.meeting-title {
		font-size: 28px;
		color: #fff;
		line-height: 35px;
		height: 70px;
		overflow: hidden;
		padding-top: 10px;
	}


	.meeting-live {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.meeting-liveTimer {
		color: #fff;
		line-height: 40px;
		font-size: 24px;

		img {
			width: 30px;
			height: 25px;
			vertical-align: -3px;
			margin-right: 5px;
		}

		.meeting-btn {
			display: inline-block;
			background: rgba(59,130,246,0.25);
			color: #fff;
			padding: 0 15px;
			border-radius: 10px;
			line-height: 40px;
		}
	}

	.noDate {
		text-align: center;
		padding: 20px;
		font-size: 26px;
		color: #64748b;
	}


	.banner-img {
		position: relative;
		background: #fff;
		min-height: 80px;
	}

	.banner-img img {
		width: 100%;
	}

	.nav-bar {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		height: 60px;
		background: rgba(0, 0, 0, .65);
		display: flex;

		.nav-bar-num {
			flex: 1;
			height: 60px;
			display: flex;
			align-items: center;
			color: #fff;
			font-size: 26px;

			img {
				width: 30px;
				height: 25px;
				margin-left: 30px;
				margin-right: 10px;
			}
		}
	}

	.nav {
		height: 76px;
		font-size: 26px;
		line-height: 76px;
		background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%) url(../../assets/home.png) no-repeat 20px center;
		background-size: 30px 30px;
		color: #fff;
		padding: 0 30px 0 60px;

		a {
			color: #fff;
		}
	}



	#foot {
		position: absolute;
		width: 100%;
		height: 50px;
		text-align: center;
		bottom: 0;
		border-top: 1px solid #e2e8f0;
		background: #f8fafc;
		padding: 10px;
		color: #64748b;
		line-height: 50px;
		margin: 0 auto;
	}

	#foot img {
		display: inline-block;
		vertical-align: top;
		height: 50px;
		margin-right: 10px;
	}
</style>
